/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 助力前十
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  activityQuery: cms.activityQuery,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.ActivityInvitationInfoDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cms/findActivityHelpTopTen`,
    data: activityQuery,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
